import BaseOptionsComponentController from '../base_options_component_controller';
import DOM from '../../../../utils/dom';
import {TimeSpan} from "@sparkware/app-utils";
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';

let view = require('./view/inactivity_timeout_settings.html');

const CSS = {
    INACTIVITY_TIME_SELECT: '.cgp-inactivity-timeout-select',
    SELECTOR_LABEL: '.cgp-inactivity-timeout-label'
};

export default class InactivityTimeoutSettingsController extends BaseOptionsComponentController {
    static CLASS = 'InactivityTimeoutSettingsController';

    _selector = 'cgp-component-inactivity-timeout-settings';

    _currentSessionTimeoutSettings = null;

    init(params) {
        super.init(params);
        this._currentSessionTimeoutSettings = this._oAuthService.getCurrentSessionTimeoutSettings();
    }

    start() {
        let bakedHTML = this.bake(view);

        this.setHTML(bakedHTML)
            ._bindOptions()
            ._setSelectorLabelText();

        return this;
    }

    _sendAnalytics(action, label) {
        let params = {
            category: 'italy_inactivity_window',
            action: action
        };

        if(label) {
            params.label = label;
        }

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, params);
    }

    _setSelectorLabelText() {
        let label = this.getEl().querySelectorAll(CSS.SELECTOR_LABEL)[0];

        label.innerHTML = this._languageService.translation('inactivity_timeout_settings_label');


        return this;
    }

    get _oAuthService() {
        return this.serviceFactory.oAuth2Service();
    }

    get _languageService() {
        return this.serviceFactory.languageService();
    }

    _getPossibleSessionTimeouts() {
        return this._currentSessionTimeoutSettings.possibleSessionTimeoutValues.map(timeSpan => Math.round(timeSpan.totalMinutes));
    }

    _getSelectorEl() {
        return this.getEl().querySelectorAll(CSS.INACTIVITY_TIME_SELECT)[0];
    }

    _bindOptions() {
        let possibleValues = this._getPossibleSessionTimeouts();


        let selector = this._getSelectorEl();

        let options = possibleValues.map(value => {
            let el = DOM.createElement('option');
            el.value = value;
            el.text = this._languageService.translation('inactivity_timeout_settings_minutes', {
                minutes: value
            });

            DOM.addClass(el, 'cgp-themes-main-text');
            DOM.addClass(el, 'cgp-theme-property-background-color-base03');

            return el;
        });

        options.forEach(option => {
            DOM.append(selector, option);
        });

        let currentSessionTimeout = this._currentSessionTimeoutSettings.currentSessionTimeout.totalMinutes;
        let index = possibleValues.findIndex(item => item === currentSessionTimeout);
        if(index >= 0) {
            selector.selectedIndex = index;
        } else {
            selector.selectedIndex = 0;
        }

        return this;
    }

    _getButtons() {
        let buttons = [
            {
                name: this._languageService.translation('inactivity_timeout_settings_save'),
                type: 'main',
                isClosable: true,
                callback: (event) => {
                    this._onSaveBtnClicked(event);
                },
                forceAnalytic: true
            }
        ];

        return buttons;
    }

    _onSaveBtnClicked() {
        let selector = this._getSelectorEl();
        let selectedValue = Number.parseInt(selector[selector.selectedIndex].value);

        if(selectedValue !== this._currentSessionTimeoutSettings.currentSessionTimeout.totalMinutes) {
            this._sendAnalytics('changed', selectedValue);
        }

        this._oAuthService.setCustomSessionTimeout(TimeSpan.fromMinutes(selectedValue));

    }

    _getTitleKey() {
        return 'inactivity_timeout_settings_title';
    }

    onComponentOpened() {
        super.onComponentClosed();
        this._sendAnalytics('open');
    }
    onComponentClosed() {
        super.onComponentClosed();
        this._sendAnalytics('closed');
    }


}